import { render, staticRenderFns } from "./buildList.vue?vue&type=template&id=7172208e&scoped=true"
import script from "./buildList.vue?vue&type=script&lang=js"
export * from "./buildList.vue?vue&type=script&lang=js"
import style0 from "./buildList.vue?vue&type=style&index=0&id=7172208e&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7172208e",
  null
  
)

export default component.exports